import type { PortalDashboardPageDefinition } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';

export const BANK_DASHBOARD_PAGES: readonly PortalDashboardPageDefinition[] = [
  {
    path: 'summary',
    label: 'Overview',
    icon: 'home',
    permission: 'overview',
    loadComponent: () => import('../overview/overview').then((m) => m.Overview),
  },
  {
    path: 'applications',
    label: 'Applications',
    icon: 'appstore',
    permission: 'applications',
    loadComponent: () =>
      import('../applications/applications').then((m) => m.Applications),
  },
  {
    path: 'drafts',
    label: 'Drafts',
    icon: 'file-protect',
    permission: 'drafts',
    loadComponent: () => import('../drafts/drafts').then((m) => m.Drafts),
  },
  {
    path: 'archived',
    label: 'Archived',
    icon: 'inbox',
    permission: 'archived',
    loadComponent: () => import('../archived/archived').then((m) => m.Archived),
  },
  {
    path: 'fees',
    label: 'Fees',
    icon: 'dollar',
    permission: 'fees',
    loadComponent: () => import('../fees/fees').then((m) => m.Fees),
  },
  {
    path: 'wallet',
    label: 'Wallet',
    icon: 'wallet',
    permission: 'wallet',
    loadComponent: () => import('../wallet/wallet').then((m) => m.Wallet),
  },
  {
    path: 'tickets',
    label: 'Tickets',
    icon: 'team',
    permission: 'tickets',
    loadComponent: () =>
      import('@dlap-ui/shared-forms/tickets/tickets-page/tickets-page').then((m) => m.TicketsPage),
  },
  {
    path: 'users',
    label: 'Users',
    icon: 'team',
    permission: 'users',
    loadComponent: () => import('../users/users').then((m) => m.Users),
  },
  {
    path: 'profile',
    label: 'Profile',
    icon: 'idcard',
    permission: 'profile',
    showInMenu: false,
    loadComponent: () => import('@dlap-ui/shared-forms/profile/profile-page/profile-page').then((m) => m.ProfilePage),
  },
  {
    path: 'memberships/members',
    label: 'Members',
    icon: 'team',
    permission: 'memberships/members',
    loadComponent: () => import('../members/members').then((m) => m.Members),
  },
] as const;
